/**
 * Theme constants for consistent styling across the app
 * Must match iOS values exactly for cross-platform consistency
 */

// Colors - matching iOS exactly
export const colors = {
  // Receipt styling
  thermalPaper: 'rgb(253, 253, 250)',  // Slight off-white for thermal paper look

  // Claimed item colors - matching iOS exactly
  claimedGreen: {
    bg: 'rgb(220, 240, 220)',    // iOS: Color(red: 0.86, green: 0.94, blue: 0.86)
    text: 'rgb(33, 140, 33)',    // iOS: Color(red: 0.13, green: 0.55, blue: 0.13)
  },

  // Primary blue
  primaryBlue: 'rgb(59, 130, 246)',  // Tailwind blue-500

  // Status colors - matching iOS exactly
  status: {
    active: 'rgb(34, 197, 94)',      // green-500
    completed: 'rgb(59, 130, 246)',   // blue-500
    cancelled: 'rgb(239, 68, 68)',    // red-500
    activeBg: 'rgba(34, 197, 94, 0.2)',
    completedBg: 'rgba(59, 130, 246, 0.2)',
    cancelledBg: 'rgba(239, 68, 68, 0.2)',
  },

  // Editable field highlighting
  editableField: 'rgba(59, 130, 246, 0.05)',

  // Error/mismatch
  error: {
    bg: 'rgba(239, 68, 68, 0.1)',
    text: 'rgb(239, 68, 68)',
  },
};

// Font sizes - matching iOS Dynamic Type
export const fontSizes = {
  caption2: '11px',   // iOS caption2
  caption: '12px',    // iOS caption
  subheadline: '15px', // iOS subheadline
  body: '17px',       // iOS body
  title3: '20px',     // iOS title3
  title2: '22px',     // iOS title2
};

// Profile bubble sizes - matching iOS exactly
export const bubbleSizes = {
  summary: 44,   // Profile summary
  item: 28,      // Item row bubbles
  drawer: 20,    // Drawer claimers
  overflow: 24,  // "+N more" bubble
};

// Spacing - matching iOS
export const spacing = {
  receiptPadding: 20,   // Horizontal padding inside receipt
  itemVertical: 8,      // Vertical padding for items
  bubbleOverlap: -8,    // Overlap for stacked bubbles (negative margin)
};
